import { render } from "./loginFormSection.vue?vue&type=template&id=6cdacde3&scoped=true"
import script from "./loginFormSection.vue?vue&type=script&lang=js"
export * from "./loginFormSection.vue?vue&type=script&lang=js"

import "./loginFormSection.vue?vue&type=style&index=0&id=6cdacde3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cdacde3"]])

export default __exports__